import { render, staticRenderFns } from "./AnnotationTextCard.vue?vue&type=template&id=0c2c4e12&scoped=true&"
import script from "./AnnotationTextCard.vue?vue&type=script&lang=js&"
export * from "./AnnotationTextCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationTextCard.vue?vue&type=style&index=0&id=0c2c4e12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2c4e12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
